<template>
  <div>
    <LeadSelect
      v-model="modelValue"
      :label="field.label"
      :options="options"
      v-bind="$attrs"
      :errors="errors"
      :placeholder="$t('campaigns.facebook.select_facebook_page_first')">
    </LeadSelect>

    <div v-if="errors && Object.keys(errors).length > 0">
      <template v-for="err in errors" :key="err">
        <FormErrorList v-if="err" :errors="err" />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import LeadSelect from './LeadSelect.vue';
import { watch, ref, type PropType } from 'vue';
import { getInstagramAccounts } from '@/api/campaign';
import { FormErrorList } from '@prospective/lithium';

const modelValue = defineModel<string | undefined>();
const options = ref<{ label: string; value: string }[]>([]);

const props = defineProps({
  facebook_page_id: {
    type: String,
    required: false,
  },
  campaign_id: {
    type: String,
    required: true,
  },
  field: {
    type: Object,
    required: true,
  },
  errors: {
    type: Object as PropType<any>,
    required: false,
  },
});

const fetchInstagramAccounts = async () => {
  if (props.facebook_page_id) {
    try {
      const res = await getInstagramAccounts(props.campaign_id, props.facebook_page_id);
      options.value = res.data.map((account) => ({
        label: account.name,
        value: account.id,
      }));
    } catch (error) {
      console.error('Error fetching Instagram accounts:', error);
    }
  }
};

watch(
  () => props.facebook_page_id,
  async (newValue) => {
    if (newValue) {
      await fetchInstagramAccounts();
    }
  },
  { immediate: true }
);
</script>
